@let content = entry().content;
@if (content.kind === 'notification') {
  <button type="button" class="toast toast--notification" cdkAriaLive="polite">
    <aw-notification-content class="compact" [notification]="content.notification" />
  </button>
} @else {
  @let informationIcon = content.icon === 'info' ? 'circle-arrow-right' : content.icon;
  @let icon = content.type === 'info' ? informationIcon : categoryIcons[content.type];
  <div
    class="toast toast--feedback"
    [attr.data-type]="content.type"
    [attr.role]="content.options.copyOnTap ? 'button' : null"
    [attr.tabindex]="content.options.copyOnTap ? 0 : null"
    [cdkAriaLive]="content.type === 'warning' ? 'assertive' : 'polite'"
  >
    @if (icon) {
      <span class="toast-icon" aria-hidden="true"><i class="aw-2-icn aw-2-icn--m" [awIcon]="icon"></i></span>
    }
    <span class="toast-message">{{ copied() ? copiedLabel : content.message }}</span>
  </div>
}
